module.exports = __webpack_public_path__ + "img/42_17.7ea1763d.png";